import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddExternalSupplierFormData } from "../types";

export const AddressField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddExternalSupplierFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography>Address</Typography>
      <TextInput className="w-full" hasError={!!errors.address} placeholder="Enter Address" maxLength={512} {...register("address")} />
      <ErrorMessage errors={errors} name="address" />
    </div>
  );
};
